import {
  Box,
  CloseButton,
  Flex,
  HStack,
  Skeleton,
  SkeletonText,
  Stack,
  useToast,
} from '@chakra-ui/react'
import groupBy from 'lodash/groupBy'
import { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import DashboardBanner from 'src/component/DashboardBanner'
import SideList from 'src/component/SideList'
import { useUser } from 'src/hooks/useUser'
import { getBanners, setSelectedLesson } from 'src/redux/actions'
import API from 'src/util/api'
import Config from 'src/util/config'
import Carousel from '../component/Carousel'
import CardLoader from 'src/component/CardLoader'
import { isMobile } from 'src/component/CourseDetail/Practice/Util'

const difficultyLevelMapper = {
  continueLearning: 'Continue Learning',
  absoluteBeginners: 'Absolute Beginners Level',
  beginner: 'Beginner Level',
  intermidiate: 'Intermediate Level',
  advanced: 'Advanced Level',
  fluent: 'Fluent Level',
  interestingStuff: 'Interesting Stuff',
  allLevels: 'All Levels',
}

const difficultyLevelOrder = {
  continueLearning: 1,
  interestingStuff: 2,
  absoluteBeginners: 3,
  beginner: 4,
  intermidiate: 5,
  advanced: 6,
  fluent: 7,
  allLevels: 8,
}
let renderNewCourseKey = []

export default function MyCourses() {
  const dispatch = useDispatch()
  const [disableLeftArrow] = useState(false)
  const [disableRightArrow] = useState(true)
  const [showAllCourse, setShowAllCourse] = useState(true)
  const toast = useToast()
  const courseDetails = useSelector(
    store => store.mainReducer.unitWiseProgressCount
  )
  const { user: auth, isAdmin } = useUser()

  const [activeItem, setActiveItem] = useState('levels')

  const onGetActivationLink = async () => {
    toast.closeAll()
    const response = await API.post(Config.API_URI + 'getActivationLink', {
      email: auth.email,
      url: window.location.origin,
    })
    if (response) {
      toast({
        status: 'success',
        title: 'You have successfully sent activation link to your account',
        position: 'bottom-left',
        isClosable: true,
        containerStyle: {
          fontSize: '14px',
        },
      })
    } else {
      toast({
        status: 'warning',
        title:
          'we are unable to get your email address, please try after sometime.',
        position: 'bottom-left',
        isClosable: true,
        containerStyle: {
          fontSize: '14px',
        },
      })
    }
  }

  const showActivationWindow = () => {
    if (auth?.isNotValidated) {
      toast({
        duration: 99000,
        render: () => (
          <HStack color="white" p={2} bg="#2469F5">
            <Box>
              Please{' '}
              <Link
                onClick={onGetActivationLink}
                href="#"
                style={{ pointer: 'cursor', textDecoration: 'underline' }}
              >
                Click here
              </Link>{' '}
              to get activation link on your email
            </Box>
            <CloseButton
              onClick={() => {
                toast.closeAll()
              }}
              size={'sm'}
            ></CloseButton>
          </HStack>
        ),
        position: 'top-right',
        isClosable: true,
        containerStyle: {
          fontSize: '14px',
          marginTop: '70px',
        },
      })
    }
  }

  useEffect(() => {
    dispatch(getBanners())
    dispatch(setSelectedLesson())
    showActivationWindow()
  }, [])
  const groupedCourse = groupBy(
    courseDetails,
    course => course?.difficultyLevel || 'interestingStuff'
  )

  const courseKeys = Object.keys(groupedCourse).sort((a, b) => {
    return difficultyLevelOrder[a] - difficultyLevelOrder[b]
  })

  const onSeeAllBtnClick = (key, showAllCourse) => {
    renderNewCourseKey = [key]
    setShowAllCourse(showAllCourse)
  }

  return (
    <Stack p={4} width="100%">
      <Helmet>
        <title>My Courses | Langistan</title>
        <meta name="description" content="Explore your enrolled courses and track your learning progress on Langistan." />
      </Helmet>
      {!courseKeys.length ?
        <>
          <Stack className='banner-skeleton-container' px="10px">
            <Skeleton height={"326px"} width="100%" borderRadius="md" />
          </Stack>
          <Box
            style={{marginTop: "30px"}}
          >
            <SkeletonText noOfLines={1} maxW="200px" borderRadius="md" />
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="flex-start"
            alignItems="flex-start"
            gap="16px"
          >
            {[...Array(isMobile ? 1 : 5)].map((_, index) => (
              <CardLoader key={index} width={`${isMobile ? "100%" : "240px"}`} height='320px' />
            ))}
          </Box>
        </> :
        <> <DashboardBanner />
          <Flex direction="row">
            <SideList activeItem={activeItem} setActiveItem={setActiveItem} />

            <Stack position="relative" overflow="hidden" marginTop={'10px'} width="100%">
              {!showAllCourse &&
                renderNewCourseKey.map(key => (
                  <Carousel
                    navUrl="coursedetails"
                    key={key}
                    auth={auth}
                    id={key}
                    courseKey={key}
                    showAllCourse={showAllCourse}
                    seeAllBtnFn={onSeeAllBtnClick}
                    contentEditable={true}
                    isAdmin={isAdmin}
                    page="courses"
                    title={difficultyLevelMapper[key]}
                    data={groupedCourse[key]}
                    disableLeftArrow={disableLeftArrow}
                    disableRightArrow={disableRightArrow}
                    cardWidth="240px"
                    cardWHeight="320px"
                    cardRatio="3/4"
                  />
                ))}
              {showAllCourse &&
                courseKeys.map(key => (
                  <Carousel
                    navUrl="coursedetails"
                    key={key}
                    auth={auth}
                    id={key}
                    courseKey={key}
                    showAllCourse={showAllCourse}
                    seeAllBtnFn={onSeeAllBtnClick}
                    contentEditable={true}
                    isAdmin={isAdmin}
                    page="courses"
                    title={difficultyLevelMapper[key]}
                    data={groupedCourse[key]}
                    disableLeftArrow={disableLeftArrow}
                    disableRightArrow={disableRightArrow}
                    cardWidth="240px"
                    cardWHeight="320px"
                    cardRatio="3 / 4"
                  />
                ))}
            </Stack>
          </Flex>
        </>
      }
    </Stack>
  )
}
